import { L10n } from '../../../ts/L10n/L10n';
import { DayCell } from './DayCell';

export class Calendar {

  // Function to return today's date
  private today: () => Date = () => new Date();

  private firstDayOfMonth: Date;
  private selectedDate: Date;
  private weeks: DayCell[][];

  constructor(month: Date) {
    this.showMonth(month);
  }

  // Useful for testing
  // TODO: maybe use an injected clock instead, which can be easily mocked/stubbed for testing
  public setToday(today: Date) {
    this.today = () => today;
    this.updateDayCells();
  }

  private showMonth(date: Date) {
    this.firstDayOfMonth = Calendar.monthOf(date || this.today());

    // TODO: the call to updateDayCells() reconstructs the weeks array, which might be a
    // performance issue.  If so, then optimize to only update the two (max) cells affected.
    this.updateDayCells();
  }

  private updateDayCells() {
    this.weeks = [];

    const firstDayOfWeek = L10n.firstDayOfWeek();
    let day = new Date(this.firstDayOfMonth.getFullYear(),
      this.firstDayOfMonth.getMonth(),
      (1 + firstDayOfWeek) - this.firstDayOfMonth.getDay());

    // Always show exactly six weeks
    for(let weekNumber = 0; weekNumber < 6; weekNumber++) {
      const days: DayCell[] = [];
      for (let i = 0; i < 7; i++) {
        const dayCell = new DayCell(day);
        dayCell.otherMonth = day.getMonth() !== this.firstDayOfMonth.getMonth();
        dayCell.selected = this.isSelected(day);
        dayCell.today = this.isToday(day);
        days.push(dayCell);
        day = new Date(day.getFullYear(), day.getMonth(), day.getDate() + 1);
      }
      this.weeks.push(days);
    }
  }

  private static monthOf(day: Date) {
    return new Date(day.getFullYear(), day.getMonth(), 1);
  }

  private static isSameDay(day1: Date, day2: Date) {
    return day1.getDate() === day2.getDate()
        && day1.getMonth() === day2.getMonth()
        && day1.getFullYear() === day2.getFullYear();
  }

  private isToday(day: Date) {
    return Calendar.isSameDay(this.today(), day);
  }

  private isSelected(day: Date) {
    return this.selectedDate && Calendar.isSameDay(this.selectedDate, day);
  }

  public select(day: Date) {
    this.selectedDate = day;
    this.showMonth(day);
  }

  public header() {
    return L10n.yearAndMonth(this.firstDayOfMonth);
  }

  public dayNames() {
    return L10n.narrowDayNames();
  }

  public getWeeks() {
    return this.weeks;
  }

  public showNext() {
    this.firstDayOfMonth = new Date(
      this.firstDayOfMonth.getFullYear(),
      this.firstDayOfMonth.getMonth() + 1,
      1);
    this.updateDayCells();
  }

  public showPrevious() {
    this.firstDayOfMonth = new Date(
      this.firstDayOfMonth.getFullYear(),
      this.firstDayOfMonth.getMonth() - 1,
      1);
    this.updateDayCells();
  }

}
